import { routes } from "../routes";
import { aimTagWithSSOLiteOnButtonClick } from "../snippets/sso/aim_tag_with_sso_lite_on_button_click";

export const ssoLitePages = [
    {
        "route": routes.html[900],
        "script": aimTagWithSSOLiteOnButtonClick,
    },
];
